var content = '_1rthyo89';
var contentIsolation = '_1rthyo8a';
var dragging = '_1rthyo8c';
var fill = '_1rthyo88';
var root = '_1rthyo83';
var scroll = {x:'_1rthyo85 _1rthyo84',y:'_1rthyo86 _1rthyo84',both:'_1rthyo87 _1rthyo84'};
var scrollBar = '_1rthyo8d';
var scrollBars = '_1rthyo8b';
var scrollPercent = 'var(--_1rthyo81)';
var scrollSize = 'var(--_1rthyo80)';

export { content, contentIsolation, dragging, fill, root, scroll, scrollBar, scrollBars, scrollPercent, scrollSize };
//# sourceMappingURL=scroll-container.css.js.map
